import { get, post } from '../../utils/http';
import { IModuleCtx } from 'models';
import { message } from 'antd';
// import { LOGIN_TYPE } from 'configs/constant/common';

export const getOaUserInfo = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getOaUserInfo', params);
  const dataList = res?.roleGroupList?.map((item: any) => ({
    value: item.roleId,
    label: item.name,
  }));
  const projectId = dataList?.[0]?.value;
  const project = projectId ? `${projectId}` : '';
  actionCtx.setState({ ...moduleState, ...res, roleList: dataList, project });

  return { ...res, roleList: dataList };
};

export const getExternalLoginConfig = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getExternalLoginConfig', params);
  actionCtx.setState({ ...moduleState, ...res });

  return { ...res };
};

export const getWxUserInfo = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getWxUserInfo', params);
  actionCtx.setState({ ...moduleState, user: res.nickname, login: !!res?.nickname, avatar: res.headimgurl, openId: res.openid });
  return { ...res };
};

export const getUserInfoByOpenid = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getUserInfoByOpenid', params);
  actionCtx.setState({ ...moduleState, user: res.nickname, login: !!res?.nickname, avatar: res.headimgurl, openId: res.openid });

  return { ...res };
};

// cache-1 的用户信息接口
// 获取wx用户头像等信息
// idList: openid数组，支持批次查询，为了排行榜上的展示
export const getUserInfo = async ({ openid = '' }) => {
  const url = '/api/user/get-userinfo';
  const res = await post(url, {
    idList: [openid],
  });
  return res;
};

// 存储wx用户头像等信息
// openid: wx用户openid, avatar: 头像cdn地址, name: wx昵称
export const setUserInfo = async ({ openid = '', avatar = '', name = '' }) => {
  const url = '/api/user/set-userinfo';
  const res = await post(url, {
    openid,
    avatar,
    name,
  });
  return res;
};

// 登录
export const login = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  try {
    const res = await post('api/user/login', params);
    actionCtx.setState({ ...moduleState, user: res?.user_name, userId: res?.user_id, login: !!res?.login, avatar: res?.avatar });
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
export const woaLogin = async (params: any) => {
  try {
    const res = await post('api/user/woaLogin', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const wxLogin = async (params: any) => {
  try {
    const res = await post('api/user/wxLogin', params);
    return { ...res };
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

// 查询用户信息
export const getPswUserInfo = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getPswUserInfo', params);
  actionCtx.setState({ ...moduleState, user: res?.user_name, userId: res?.user_id, login: !!res?.login, avatar: res?.avatar });
  return { ...res };
};

// cai表管理的用户信息
export const getCaiDataUserInfo = async (params: any, moduleState: any, actionCtx: IModuleCtx) => {
  const res = await get('api/user/getCaiDataUserInfo', params);
  actionCtx.setState({
    ...moduleState,
    userName: res?.user_name,
    userId: res?.user_id,
    accountType: res?.account_type,
    authList: res?.auth?.split(',').map((i: string) => Number(i)) || [],
    userRole: res?.user_role?.split(',').map((i: string) => Number(i)) || [],
    defaultAppId: res?.default_app_id,
  });
  return { ...res };
};
